import api from "../_api";

const actions = {
    updatePrice: ({ commit, dispatch }, payload) => {
        commit("UPDATE_PRICE", payload.price);
    },
    updatePlanCart: ({ commit, dispatch }, payload) => {
        commit("UPDATE_PLAN_CART", payload);
    },
    updatePlans: ({ commit, dispatch }, payload) => {
        commit("UPDATE_PLANS", payload);
    },
    planErrors: ({ commit, dispatch }, payload) => {
        commit("PLAN_ERROR", payload);
    },
    clearPlanErrors: ({ commit, dispatch }) => {
        commit("CLEAR_PLAN_ERROR");
    },
    plansRequest: ({ commit, dispatch }) => {
        return new Promise((resolve, reject) => {
            commit("PLAN_LOADING");

            api.plans()
                .then(resp => {
                    commit("PLAN_SUCCESS", resp.data.data);
                    resolve(resp.data);
                })
                .catch(err => {
                    let errors = { error: "Techinal Issue, Please try again later" };
                    let errorMsg = errors.error;
                    if (err.response.status != 500) {
                        errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;
                    }

                    commit("PLAN_ERROR", errors);
                    reject(errorMsg);
                });
        });
    },
    resetTotals: ({ commit }) => {
        commit("RESET_TOTALS");
    },
    payPlan: ({ commit, dispatch, state }, payload) => {
        let data = {
            cardData: payload.cardPayload,
            couponCart: payload.couponCart,
            donationCart: payload.donationCart,
            plan: payload.plan,
            planCart: state.planCart,
        };

        return new Promise((resolve, reject) => {
            commit("PAYMENT_LOADING");

            api.payPlan(data)
                .then(resp => {
                    commit("PAYMENT_SUCCESS", resp.data);
                    dispatch("user/userRequest", null, { root: true });
                    resolve(resp.data.data);
                })
                .catch(err => {
                    let errors = err.response.data;

                    commit("PAYMENT_ERROR", errors);
                    reject(err.response);
                });
        });
    },
    clearPaymentErrors: ({ commit }) => {
        commit("CLEAR_PAYMENT_ERRORS");
    },
};

export default actions;
